<template>
	<div class="memberCenter layui-layout layui-layout-admin" style="background:#fff;">
		<div class="layui-header al_itm" style="background:#fff;">
			<div class="px18 al_itm" style="color:#000;margin-left:20px;">
				会员中心
			</div>
		</div>
		<!-- 会员中心模块 -->
		<div>
			<div style="padding: 20px;" class="border_b px16">
				<div class="f_row al_itm" style="margin-bottom:20px;line-height: 50px;font-size: 18px;">
					<span>姓名: {{userInfo.name ? userInfo.name : '姓名'}}</span>
					<span style="margin-left:30px;">ID: {{userInfo.id}}</span>
					<span class="pointer" style="margin-left:30px;">评分: {{userInfo.score ? userInfo.score : 0}}</span>
					<el-button type="primary" style="margin-left: 20px;" @click="explain = true">工资报酬说明</el-button>
					<el-button type="danger" style="margin-left: 20px;" @click="onPDF">工程师必读</el-button>
					<el-button type="success" style="margin-left: 20px;" @click="onPDF2">国家SMT行业标准</el-button>
				</div>
				<el-dialog :title="describe.title" :visible.sync="explain" width="70%" :close-on-click-modal='false' :append-to-body="true" :close-on-press-escape='false' center>
				<div v-html="describe.content"></div>
				<div slot="footer" class="dialog-footer">
					<el-button type="primary" @click="explain = false">关闭</el-button>
				</div>
			</el-dialog>
				<div class="f_row al_itm" style="margin-bottom:10px;">
					<span>{{userInfo.online_status == 1 ? '在线':'离线'}}</span>
					<div class="layui-form margin_l20">
						<input type="checkbox" name="switch" lay-skin="switch" id="switch">
					</div>
					<span class="margin_l20 px14" style="color:#707070;">{{userInfo.online_status == 1 ? '在线状态可进行接单或系统派单':'离线状态不可进行接单或系统派单'}}</span>
				</div>
			</div>
			<div class="f_row al_itm jc_sb" style="padding: 30px 0;border-bottom:1px solid #bbb;font-family:SourceHanSansSC;">
				<div class="f_col al_itm" style="width:50%;">
					<span class="px24 color_4a">当月接单量</span>
					<span class="px24" style="padding:30px 0;">{{orderInfo.total}}</span>
					<span class="px16 color_q">距目标还差{{orderInfo.task}}</span>
				</div>
				<div class="f_col al_itm" style="width:50%;">
					<span class="px24 color_4a">当月完成订单</span>
					<span class="px24" style="padding:30px 0;">{{orderInfo.month}}</span>
					<div class="f_row al_itm px16">
						<span class="zt_txt_color">准时交付{{orderInfo.ontime}}%</span>
						<span class="mon_color" style="margin-left:20px;">品质{{orderInfo.quality}}%</span>
					</div>
				</div>
			</div>
			<div class="f_row al_itm jc_sb" style="padding: 30px 0;font-family:SourceHanSansSC;">
				<div class="f_col al_itm" style="width:50%;">
					<span class="px24 color_4a">累计接单量</span>
					<span class="px24" style="padding:30px 0;">{{orderInfo.get}}</span>
				</div>
				<div class="f_col al_itm" style="width:50%;">
					<span class="px24 color_4a">进行中订单</span>
					<span class="px24" style="padding:30px 0;">{{orderInfo.conduct}}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'memberCenter',
		data() {
			return {
				tables: '',
				online: false,
				userInfo: '',
				orderInfo: {
					total: 0,
					task: 0,
					month: 0,
					get: 0,
					conduct: 0,
					ontime: 0,
					quality: 0
				},
				pages: 1,
				limit: 10,
				count: 1,
				describe: '',
				explain: false,
			}
		},
		created() {
			this.onGcsWages();
		},
		mounted() {
			let _this = this;
			layui.use(['form', 'laypage', 'layer', 'table'], function() {
				var laypage = layui.laypage;
				var forms = layui.form;
				var table = layui.table;
				forms.render();
				api.getMemberInfo({ //获取用户信息
					token: _this.getCookie('token')
				}).then((res) => {
					if(res.code == 1) {
						_this.userInfo = res.data;
						if(res.data.online_status == 1) {
							$("#switch").attr('checked', true);
							forms.render();
						}
					} else if(res.code == 0) {
						layer.msg(res.msg, {
							icon: 2,
							anim: 6
						})
					}
				});
				api.getOrderCountInfo({ //获取订单完成信息
					token: _this.getCookie('token')
				}).then((res) => {
					if(res.code == 1) {
						_this.orderInfo = res.data;
					} else if(res.code == 0) {
						layer.msg(res.msg, {
							icon: 2,
							anim: 6
						})
					}
				});
				forms.on('switch', function(e) {
					if(e.elem.checked) {
						_this.changeStatus(1)
					} else {
						_this.changeStatus(0)
					}
				});
			});
		},
		methods: {
			changeStatus(num) {
				let _this = this;
				api.changeOnLineStatus({
					token: _this.getCookie('token'),
					status: num
				}).then((res) => {
					if(res.code == 1) {
						_this.userInfo.online_status = num;
					} else if(res.code == 0) {
						layer.msg(res.msg, {
							icon: 2,
							anim: 6
						})
					}
				})
			},
			onGcsWages() {
				let _this = this;
				api.gcsWages({
					token: this.getCookie('token'),
				}).then((res) => {
					if(res.code == 1) {
						_this.describe = res.data;
					}
				})
			},
			onPDF() {
				window.open('https://mr.summary88.com/mrgw_gcsd/《桃琼之瑶技术标准制作说明》.pdf');
			},
			onPDF2() {
				window.open('https://mr.summary88.com/mrgw_gcsd/表面贴装技术印刷行业标准.pdf');
			},
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	
</style>


// WEBPACK FOOTER //
// src/components/memberCenter.vue